// Packages
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import spectrumTheme from './styles/spectrum-material-theme';
import Routes from './routes/Routes';

// Styles
import './App.css';
import { appConstants } from './constants/apiConstants';

const App = () => {
  if (window.self === window.top) {
    window.location.href = appConstants.parentURL;
  }
  return (
    <BrowserRouter>
      <ThemeProvider theme={spectrumTheme}>
        <Routes />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
